import { useRequiredParams } from 'hooks/params.hook'
import { useNavigate } from 'react-router-dom'

export const useGoToMoveContainers = () => {
  const navigate = useNavigate()
  const { receiptType } = useRequiredParams('receiptType')

  return {
    go: (receiptId: string, orderId: string) => {
      navigate(
        MOVE_CONTAINERS_URL.replace(':receiptType', receiptType)
          .replace(':receiptId', receiptId)
          .replace(':orderId', orderId)
      )
    }
  }
}

export const MOVE_CONTAINERS_URL =
  '/receipt/:receiptType/:receiptId/order/:orderId/containers'
